<template>
    <div class="pt-4 p-4 flex flex-col items-center bg-light-bg dark:bg-dark-bg min-h-screen text-light-text dark:text-dark-text">
      <AppSidebar />
  
      <div class="w-full max-w-6xl bg-white dark:bg-dark-box-bg rounded-lg shadow-md p-6 mt-6">
      <div v-if="message" :class="messageType" 
          class="fixed top-0 left-0 right-0 z-5 p-4 rounded-lg mb-4 text-center 
                  bg-white dark:bg-dark-box-bg dark:text-dark-text dark:border 
                  dark:border-dark-border">
          {{ message }}
          <div class="absolute bottom-0 left-0 h-1 rounded-lg" 
              :style="{ width: progress + '%', backgroundColor: getProgressColor(), borderRadius: '8px' }">
          </div>
      </div>
        <button
          @click="goToPayoffs"
          class="mb-4 text-teal-700 dark:text-teal-400 hover:underline flex items-center"
        >
          &larr; Wróć do zakładki Rozliczeń
        </button>

        <div v-if="payoff">
          <h2 class="text-2xl font-bold mb-6">Profil Rozliczenia</h2>
  
          <!-- Driver Information Grid -->
          <div class="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-6 mb-6">
            <div class="space-y-2">
              <p><strong>Imie i Nazwisko Kierowcy:</strong> {{ payoff.driver.firstName || 'Nie podano' }} {{ payoff.driver.lastName || 'Nie podano' }}</p>
            </div>
          </div>
  
          <hr class="my-6 border-light-border dark:border-dark-border">
  
          <!-- Orders Table -->
          <h4 class="text-lg font-semibold mb-4">Zlecone Zamówienia</h4>

          <div class="flex items-center space-x-4">
              <label for="status-filter" class="my-8 text-sm font-medium text-gray-700 dark:text-gray-300">Filtruj według:</label>
              <select id="status-filter" v-model="selectedFilter" @change="filterOrders"
                      class="block pl-3 pr-10 py-2 text-sm bg-light-bg text-light-text border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 rounded-md dark:bg-dark-box-bg dark:text-dark-text dark:border-dark-border w-full sm:w-48">
                <option value="all" class="text-dark-status-available dark:text-dark-status-available">Wszystkie</option>
                <option value="week" class="text-orange-500 dark:text-orange-500">Ostatni tydzień</option>
                <option value="month" class="text-dark-status-pending dark:text-dark-status-pending">Ostatni miesiąc</option>
              </select>
            </div>

          <div class="overflow-x-auto">
            <table class="w-full border-collapse border border-light-border dark:border-dark-border">
              <thead>
                <tr class="bg-light-table-header dark:bg-dark-table-header">
                  <th class="border border-light-border dark:border-dark-border px-4 py-2 text-left">#</th>
                  <th class="border border-light-border dark:border-dark-border px-4 py-2 text-left">Numer Zamówienia</th>
                  <th class="border border-light-border dark:border-dark-border px-4 py-2 text-left">Data</th>
                  <th class="border border-light-border dark:border-dark-border px-4 py-2 text-left">Kilometry z Aplikacji</th>
                  <th class="border border-light-border dark:border-dark-border px-4 py-2 text-left">Kilometry Kierowcy</th>
                  <th class="border border-light-border dark:border-dark-border px-4 py-2 text-left">Kilometry Dyspozytora</th>
                  <th class="border border-light-border dark:border-dark-border px-4 py-2 text-left">Oczekiwanie na Pasażera</th>
                  <!-- <th class="border border-light-border dark:border-dark-border px-4 py-2 text-left">Cena za Km</th> -->
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(order, index) in paginatedOrders"
                  :key="order.id"
                  @click="startEditing(order)"
                  :class="[order.payoff ? 'bg-green-200 dark:bg-green-600' : 'bg-red-200 dark:bg-red-400', 'border-b border-gray-300 dark:border-dark-border']"
                  class="cursor-pointer"
                >
                  <td class="border border-light-border dark:border-dark-border px-4 py-2">{{ index + 1 }}</td>
                  <td 
                    @click="goToProfile(order)"
                    class="border border-light-border dark:border-dark-border px-4 py-2 text-teal-700 dark:text-white hover:underline">
                    Zamówienie {{ order.mpk }}
                  </td>
                  <td class="border border-light-border dark:border-dark-border px-4 py-2">
                    {{ new Date(order.date).toLocaleDateString() }}
                  </td>
                  <td class="border border-light-border dark:border-dark-border px-4 py-2">
                    {{ order.distanceInKm }} Km
                  </td>
                  <td class="border border-light-border dark:border-dark-border px-4 py-2">
                    {{ order.driverKilometers.toFixed(2) }} Km
                  </td>
                  <td class="border border-light-border dark:border-dark-border px-4 py-2">
                    {{ order.dispatcherKilometers.toFixed(2) }} Km
                  </td>
                  <td class="border border-light-border dark:border-dark-border px-4 py-2">
                    <!-- Jeśli istnieje przynajmniej jeden pasażer, sprawdzamy czas oczekiwania -->
                    <span v-if="order.passenger.length > 0">
                      {{ totalPassengerWaitingTime(order.passenger) }} Min
                    </span>
                    <span v-else>Brak pasażera</span>
                  </td>
                  <!-- <td class="border border-light-border dark:border-dark-border px-4 py-2">
                    {{ order.pricePerKilometer }} zł
                  </td> -->
                </tr>
              </tbody>
            </table>
          </div>

          <div class="mt-4 flex flex-col sm:flex-row items-center justify-between space-y-4 sm:space-y-0">
            <!-- Informacja o liczbie wyświetlanych elementów -->
            <div class="text-center sm:text-left text-sm text-light-text dark:text-gray-400">
              Wyświetlono {{ (currentPage - 1) * itemsPerPage + paginatedOrders.length }} z {{ this.payoff?.driver?.orders.length }} zleceń
            </div>

            <!-- Kontrolki paginacji -->
            <div class="flex flex-wrap justify-center sm:justify-end items-center gap-2">
              <!-- Przycisk "Pierwsza strona" -->
              <button v-if="currentPage > 1"
                      @click="goToPage(1)"
                      class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
                Pierwsza strona
              </button>

              <!-- Przycisk "Poprzednia" -->
              <button v-if="currentPage > 1"
                      @click="prevPage"
                      class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
                &laquo; Poprzednia
              </button>

              <!-- Numerowane strony -->
              <button v-for="page in visiblePages"
                      :key="page"
                      @click="goToPage(page)"
                      :class="[currentPage === page ? 'bg-teal-700 text-white' : 'bg-gray-200 dark:bg-dark-box-bg text-gray-700 dark:text-dark-text']"
                      class="px-3 py-1 text-sm font-medium rounded-md transition-colors hover:bg-teal-700 hover:text-white dark:hover:bg-teal-600 dark:hover:text-white">
                {{ page }}
              </button>

              <!-- Przycisk "Następna" -->
              <button v-if="currentPage < totalPages"
                      @click="nextPage"
                      class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
                Następna &raquo;
              </button>

              <!-- Przycisk "Ostatnia strona" -->
              <button v-if="currentPage < totalPages"
                      @click="goToPage(totalPages)"
                      class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
                Ostatnia strona
              </button>
            </div>
          </div>

          <hr class="my-6 border-light-border dark:border-dark-border">
        </div>
  
        <!-- Loading State -->
        <div v-else-if="loading" class="text-gray-500 dark:text-gray-400">
          <p>Ładowanie danych rozliczenia...</p>
        </div>
  
        <!-- Error State -->
        <div v-else-if="errorMessage" class="text-red-500 dark:text-red-400">
          <p>{{ errorMessage }}</p>
        </div>
  
      </div>
    </div>

      
    <OrderPayoffEditModal
          :isOpen="isEditModalOpen"
          :editingOrder="editingOrder"
          @close="closeEditModal"
          @submit="handleOrderEditSubmit"
        />
  </template>
  
  <script>
  import { useAuthStore } from '@/stores/authStore';
  import AppSidebar from '@/components/AppSidebar.vue';
  import payoffService from '@/services/payoffService';
import OrderPayoffEditModal from '../orders/OrderPayoffEditModal.vue';
import orderService from '@/services/orderService';
  
  export default {
    name: 'PayoffProfile',
    components: {
        AppSidebar,
        OrderPayoffEditModal
    },
    data() {
      return {
        payoff: null,
        loading: true,
        errorMessage: '',
        selectedFilter: 'all',
        filteredOrders: [],
        message: '',
        messageType: '',
        progress: 0,
        showModal: false,
        isEditModalOpen: false,
        editingOrder: null,
        pricePerKilometer: 0,
        currentPage: 1,
        itemsPerPage: 5, // Liczba elementów na stronę
        totalPages: 0, // Łączna liczba stron
        visiblePages: [], // Widoczne numery stron w paginacji
      };
    },
    setup() {
      const authStore = useAuthStore();
      authStore.checkExpiration();
      return { user: authStore.user };
    },
    mounted() {
      this.fetchPayoff();
    },
    watch: {
      allOrders: {
        immediate: true,
        handler() {
          this.filterOrders();
        }
      },
      totalPages() {
        this.updateVisiblePages();
      }
    },
    computed: {
        totalAppKilometers() {
          return this.payoff?.driver?.orders?.reduce((sum, order) => sum + (!order.payoff ? (order.distanceInKm || 0) : 0), 0);
        },
        totalDriverKilometers() {
          return this.payoff?.driver?.orders?.reduce((sum, order) => sum + (!order.payoff ? (order.driverKilometers || 0) : 0), 0);
        },
        totalDispatcherKilometers() {
          return this.payoff?.driver?.orders?.reduce((sum, order) => sum + (!order.payoff ? (order.dispatcherKilometers || 0) : 0), 0);
        },
        totalCostApp() {
            return (this.totalAppKilometers * this.pricePerKilometer).toFixed(2);
        },
        totalCostDriver() {
            return (this.totalDriverKilometers * this.pricePerKilometer).toFixed(2);
        },
        totalCostDispatcher() {
            return (this.totalDispatcherKilometers * this.pricePerKilometer).toFixed(2);
        },
        allOrders() {
          return this.payoff?.driver?.orders || [];
        },
        paginatedOrders() {
          const start = (this.currentPage - 1) * this.itemsPerPage;
          const end = start + this.itemsPerPage;
          return this.filteredOrders.slice(start, end);
        },
    },
    methods: {
      filterOrders() {
        const now = new Date();
        this.filteredOrders = this.allOrders.filter(order => {
          const orderDate = new Date(order.date);
          if (this.selectedFilter === 'week') {
            const oneWeekAgo = new Date();
            oneWeekAgo.setDate(now.getDate() - 7);
            return orderDate >= oneWeekAgo;
          } else if (this.selectedFilter === 'month') {
            const oneMonthAgo = new Date();
            oneMonthAgo.setMonth(now.getMonth() - 1);
            return orderDate >= oneMonthAgo;
          }
          return true;
        });

        this.calculateTotalPages();
      },
      async fetchPayoff() {
        const payoffId = this.$route.params.id || this.$route.query.payoffId; // Sprawdź `query`
        if (!payoffId) {
          this.errorMessage = 'Brak ID rozliczenia.';
          return;
        }
        this.loading = true;
        this.errorMessage = '';
        try {
          const response = await payoffService.getPayoffById(payoffId);
          this.payoff = response.data; // Zapisujemy payoffDTO, które zawiera driver i orders
        } catch (error) {
          console.error('Error fetching driver details:', error);
          this.errorMessage = 'Nie udało się pobrać szczegółów rozliczenia. Spróbuj ponownie później.';
        } finally {
          this.loading = false;
        }
      },
      goToPayoffs() {
        const returnTo = this.$route.query.returnTo;
        const currentPage = this.$route.query.currentPage;
        if (returnTo) {
          this.$router.push({ 
            name: returnTo,
            query: {currentPage: currentPage}  
          });
        } else {
          if (this.user.role === 'ROLE_ADMIN') {
            this.$router.push({name: 'PayoffPageAdmin', query: {currentPage: currentPage} });
          } else {
            this.$router.push({name: 'PayoffPageDispatcher', query: {currentPage: currentPage} });
          }
        }
      },
      goToProfile(order) {
        const role = this.user.role;
        const routeName = role === 'ROLE_ADMIN' ? 'OrderProfileAdmin' : 'OrderProfileDispatcher';
        this.$router.push({
          name: routeName,
          params: { id: order.id },
          query: {
            returnTo: this.$route.name,
            payoffId: this.payoff.payoffId,
          },
        });
      },
      calculateWaitingTime(startTime, endTime) {
        const diffMs = new Date(endTime) - new Date(startTime);
        const diffMinutes = Math.floor(diffMs / (1000 * 60));

        console.log(startTime, endTime)
        console.log(diffMinutes)

        // Zaczynamy liczyć dopiero po 60 minutach
        return diffMinutes > 60 ? diffMinutes - 60 : 0;
      },
      totalPassengerWaitingTime(passengers) {
        if (!Array.isArray(passengers)) return 0;

        return passengers.reduce((total, p) => {
          if (p.waitingStartTime && p.waitingEndTime) {
            return total + this.calculateWaitingTime(p.waitingStartTime, p.waitingEndTime);
          }
          return total;
        }, 0);
      },
      startEditing(order) {
            this.showModal = false;
            this.openEditModal(order);
        },
        openEditModal(order) {
            this.editingOrder = order;
            this.isEditModalOpen = true;
        },
        closeEditModal() {
            this.isEditModalOpen = false;
            this.editingOrder = null;
        },
        handleOrderEditSubmit(editingOrder) {
            if (!this.loading) {
                this.submitEdit(editingOrder);
            }
        },
        async submitEdit(editingOrder) {
            if (this.loading) return;

            this.loading = true;
            try {
                const orderData = {
                    id: editingOrder.id,
                    dispatcherKilometers: editingOrder.dispatcherKilometers,
                    driverKilometers: editingOrder.driverKilometers,
                    pricePerKilometer: editingOrder.pricePerKilometer,
                    payoff: editingOrder.payoff,
                    highway: editingOrder.highway,
                    driverGates: editingOrder.driverGates,
                    additvies: editingOrder.additvies,
                    flatRate: editingOrder.flatRate,
                    totalAmount: editingOrder.totalAmount
                };

                await orderService.updatePayoff(orderData.id, orderData);
                await this.fetchPayoff();
                this.closeEditModal();
                this.showMessage("Rozliczenie zostało pomyślnie zaaktualizowane.", "success");
            } catch (error) {
                this.showMessage("Wystąpił błąd podczas aktualizacji rozliczenia.", "error");
                console.error('Błąd podczas aktualizacji rozliczenia:', error);
            } finally {
                this.loading = false;
            }
        },
        showMessage(msg, type) {
            this.message = msg;
            this.messageType = type === 'success' ? 'success-message' : 'error-message';
            this.progress = 0;

            const interval = 30;
            const duration = 5000;
            const step = 100 / (duration / interval);

            const progressInterval = setInterval(() => {
                this.progress += step;
                if (this.progress >= 100) {
                clearInterval(progressInterval);
                this.progress = 0;
                this.message = '';
                this.messageType = '';
                }
            }, interval);
        },
        getProgressColor() {
          return this.messageType === 'success-message' ? '#16a34a' : '#b91c1c';
        },
        calculateTotalPages() {
          this.totalPages = Math.ceil(this.filteredOrders.length / this.itemsPerPage);
          this.updateVisiblePages();
        },
      updateVisiblePages() {
        const range = 5; // Liczba stron do wyświetlenia na raz
        const start = Math.max(1, this.currentPage - Math.floor(range / 2));
        const end = Math.min(start + range - 1, this.totalPages);

        this.visiblePages = Array.from({ length: end - start + 1 }, (_, i) => start + i);
      },
      goToPage(page) {
        this.currentPage = page;
        this.updateVisiblePages();
      },
      nextPage() {
        if (this.currentPage < this.totalPages) {
          this.currentPage++;
          this.updateVisiblePages();
        }
      },
      prevPage() {
        if (this.currentPage > 1) {
          this.currentPage--;
          this.updateVisiblePages();
        }
      },
    }
  };
</script>
